import React, { Fragment } from 'react';
import { func, string, number } from 'prop-types';
import {
    compose,
    setDisplayName,
    renderNothing,
    branch,
    withProps,
    withState,
    withHandlers,
} from 'react-recompose';
import styled from 'styled-components';
import { Menu, Image, Ref, Label } from 'semantic-ui-react';

import nobleSVG from '~/images/noblehour.svg';
import collabSVG from '~/images/collaboratory.svg';

import withReduxConnect from '~/views/enhancers/withReduxConnect';

import ui from '~/state/ducks/ui/actions';
import { getIsEnvProduction } from '~/state/ducks/app/selectors';
import { getNavbarHeight } from '~/state/ducks/ui/selectors';
import { getBaseURL, isAuthenticated, getProductID } from '~/state/ducks/auth/selectors';
import { logout } from '~/state/ducks/auth/operations';

import mapping from '~/utils/mapping.json';


const Spacer = styled.div`
    padding-top: ${p => p.padding}px;
`;

const Navbar = ({
    handleLogout,
    handleToggleSidebar,
    handleNavbarRef,
    handleNavbarLoad,
    navbarHeight,
    productImage,
    targetAPI,
}) => (
    <Fragment>
        <Ref innerRef={handleNavbarRef}>
            <Menu inverted borderless fixed="top">
                <Menu.Item onClick={handleToggleSidebar}>
                    <Image
                        src={productImage}
                        size="small"
                        onLoad={handleNavbarLoad}
                    />
                </Menu.Item>

                <Menu.Menu position="right">
                    <Menu.Item>
                        <Label basic color="black" icon="database" content={targetAPI} />
                    </Menu.Item>

                    <Menu.Item
                        link
                        active
                        onClick={handleLogout}
                        color="blue"
                        content="Log out"
                    />
                </Menu.Menu>
            </Menu>
        </Ref>

        <Spacer $padding={navbarHeight} />
    </Fragment>
);

Navbar.propTypes = {
    productImage: string.isRequired,
    handleLogout: func.isRequired,
    handleToggleSidebar: func.isRequired,
    handleNavbarRef: func.isRequired,
    handleNavbarLoad: func.isRequired,
    navbarHeight: number.isRequired,
    targetAPI: string.isRequired,
};

export default compose(
    setDisplayName('NavbarContainer'),
    withReduxConnect({
        mapStateToProps: state => ({
            isEnvProduction: getIsEnvProduction(state),
            isAuthenticated: isAuthenticated(state),
            targetAPI: getBaseURL(state),
            productID: getProductID(state),
            navbarHeight: getNavbarHeight(state),
        }),
        mapDispatchToProps: {
            handleLogout: logout,
            handleToggleSidebar: ui.sidebar.toggle,
            handleSetNavbarHeight: ui.navbar.setHeight,
        },
    }),
    branch(({ isAuthenticated }) => !isAuthenticated, renderNothing),
    withProps(({ productID, targetAPI, isEnvProduction }) => ({
        targetAPI: isEnvProduction
            ? 'Production'
            : targetAPI.replace(/https?:\/\/(.*)$/, '$1'),
        productImage: productID === mapping.license.by_name.NOBLEHOUR
            ? nobleSVG
            : collabSVG,
    })),
    withState('navbarRef', 'handleNavbarRef'),
    withHandlers({
        handleNavbarLoad: ({ navbarRef, handleSetNavbarHeight }) => () => {
            handleSetNavbarHeight(navbarRef);
        },
    }),
)(Navbar);
